/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EntryDto } from '../../models/entry-dto';
import { EntryForm } from '../../models/entry-form';

export interface InsertEntry$Params {

/**
 * UUID to identify the customer
 */
  customerId: string;

/**
 * UUID to identify the svg (tenancy id)
 */
  svgId: string;
      body: EntryForm
}

export function insertEntry(http: HttpClient, rootUrl: string, params: InsertEntry$Params, context?: HttpContext): Observable<StrictHttpResponse<EntryDto>> {
  const rb = new RequestBuilder(rootUrl, insertEntry.PATH, 'post');
  if (params) {
    rb.path('customerId', params.customerId, {});
    rb.path('svgId', params.svgId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EntryDto>;
    })
  );
}

insertEntry.PATH = '/svgs/{svgId}/customers/{customerId}/journal';
